/**
 * Servicio de autenticación para manejar tokens y headers
 */

export const getAuthToken = (): string | null => {
  try {
    const authData = localStorage.getItem('client-auth-storage');
    if (!authData) return null;

    const parsed = JSON.parse(authData);
    return parsed.state?.token || null;
  } catch (error) {
    console.error('Error getting auth token:', error);
    return null;
  }
};

export const getAuthHeaders = (): Record<string, string> => {
  const token = getAuthToken();
  
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

export const isAuthenticated = (): boolean => {
  const token = getAuthToken();
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp > currentTime;
  } catch (error) {
    console.error('Error validating token:', error);
    return false;
  }
};
